import { either, isEmpty, isNil } from 'ramda'

/*
  * Returns true if the value is either null, undefined, or an empty string, array, or object.
  Uses ramda's `isNil` and `isEmpty` functions.
  */
export const isEmptyOrNil = either(isNil, isEmpty)
